<template>
  <div class="category">
    <mbHeader title="" :lang="true">
      <div class="search-bar">
        <afmSearchType class="mobile-search-afm-search-type"></afmSearchType>
        <input
          type="text"
          :placeholder="$t('search')"
          v-model="searchTerm"
          @keypress.enter="searchProduct"
        >
        <div class="hoverBtn" @click="searchProduct">
          <font-awesome-icon icon="search" :style="{ color: 'white', fontSize: '12px' }"/>
        </div>
      </div>
    </mbHeader>

    <ul class="allGroups" v-if="!isLoading">
      <li v-for="(item,index) in groupOptions" :key="index">
        <div class="groupImg" @click="navigateHeader(item)">
          <img :src="item.Image" alt="">
        </div>
        <span v-if="$i18n.locale == 'en'" class="group-button-name">{{ item.label }}</span>
        <span v-if="$i18n.locale == 'ch'" class="group-button-name">{{ item.description }}</span>
      </li>
    </ul>

    <div v-else class="loadings">
      <img src="../../assets/img/loading.gif" alt="">
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

import Utils from "../../assets/js/util";
import mbHeader from "../../components/mobile/mbHeader";
import afmSearchType from '@/components/afm-search-type/afm-search-type';

export default {
  name: "Category",
  components: {
    mbHeader,
    afmSearchType
  },
  data() {
    return {
      searchTerm: '',
      groupOptions: [],
      isLoading: false,
    }
  },
  mounted() {
    this.isLoading = true
    // console.log(this.allGroups);
  },
  methods: {
    ...mapMutations('products', ['updateSelectedSearchGlobal']),
    searchProduct() {
      Utils.$emit("clearList");
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewSearch(this.searchTerm, 'Name');
      }, 300);
    },
    navGo(id) {
      const group = this.allGroups.filter( group => group.ProductGroup_id === id)[0];
      Utils.$emit("clearList");
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewGroup(group);
      }, 300);
    },
    navigateHeader(val) {
      this.navGo(val.value)
    },
    sort(newVal) {
      let cascadeOptions = [];
      newVal.map(group => {
        let groupObj = {};
        groupObj.value = group.ProductGroup_id;
        groupObj.label = group.Name;
        groupObj.Image = group.Image;
        groupObj.group = true;
        groupObj.children = [];
        groupObj.description = group.Description;
        if (group.Categories.length > 0) {
          group.Categories.map(category => {
            let catObj = {};
            catObj.label = category.Name;
            catObj.value = category.ProductCategory_id;
            catObj.group = false;
            catObj.parentValue = group.ProductGroup_id;
            catObj.parentName = group.Name;
            catObj.description = category.Description;
            groupObj.children.push(catObj);
          })
        }
        cascadeOptions.push(groupObj);
      });
      this.isLoading = false;
      this.groupOptions = cascadeOptions;
      // console.log(this.groupOptions);
    }
  },
  activated() {
    // console.log(this.allGroups);
    if(this.allGroups.length>0) {
      this.sort(this.allGroups)
    }
  },
  computed: mapState({
    allGroups: state => state.navbar.allGroups,
  }),
  watch: {
    allGroups: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.sort(newVal)
      }
    },
  }
}
</script>

<style scoped lang="less">
.category {
  min-height: 100vh;
  padding: 66px 16px 80px;
  display: flex;
  flex-flow: column;

  .mbheader {
    height: 60px;

    .search-bar {
      input {
        &::placeholder {
          color: #7cc26a;
        }
      }
    }
  }

  .allGroups {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &:after {
      content: "";
      visibility: hidden;
      width: calc(33.3% - 8px);
    }

    li {
      width: calc(33.3% - 5px);
      display: flex;
      flex-flow: column;
      align-items: center;
      margin-bottom: 16px;
      .groupImg {
        width: 90px;
        height: 90px;
        display: flex;
        align-items: center;
        border-radius: 5px;
        box-shadow: 1px 3px 4px 2px rgba(0, 0, 0, 0.05);
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      span{
        font-size: 10px;
        display: block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
      }

    }
  }

  .loadings{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 100px;
      height: 100px;
      display: block;
    }
  }
}

@media only screen and (min-width: 768px) {
  .category {
    padding: 0 135px;

    .allGroups {
      display: flex;
      justify-content: flex-start;

      li {
        width: max-content;
        padding: 0 20px;

        .groupImg {
          width: 183px;
          height: 162px;
          margin-bottom: 20px;
        }

        span {

        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .category {
    .allGroups {
      li {
        .groupImg {
          padding: 8%;
        }

        .group-button-name {
          font-family: 'SourceSansPro-bold', 'Source Sans Pro';
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/Category.vue